import crudAction from './actions'

export default {
  name: 'customerServicesUsers',
  namespace: 'customer_services_users',
  methods: [
    ...crudAction,
  ]
}